/**
 * Created by Vladislav on 26.09.2024.
 */

Placements.ENTRIES = {
    displaySceneIntro: {
        type: Placements.FREE_FOCUS,
        priority: 100,
        filter: function () {
            return !cleverapps.Scenes.GetRunningScene().introShown;
        },
        action: function () {
            const scene = cleverapps.Scenes.GetRunningScene();

            cleverapps.focusManager.display({
                focus: "Scene.intro",
                actions: [
                    function (f) {
                        scene.introShown = true;

                        const silent = cleverapps.silentIntro; 

                        scene.sceneComponent.playIntro(f, silent);
                    },
                    function (f) {
                        cleverapps.restoreProgress.update();
                        cleverapps.silentIntro = false;

                        f();
                    }
                ]
            });
        }
    },

    recalculateFlags: {
        type: Placements.ONSHOW_OR_STARTUP | Placements.INTERMEDIATE_OR_AFTER_FINISH,
        action: function () {
            cleverapps.flags.update();
        }
    },

    prefabPlayerRun: {
        type: Placements.FREE_FOCUS,
        priority: -1000,
        filter: function () {
            return cleverapps.prefabPlayer && !cleverapps.prefabPlayer.options.download && !cleverapps.prefabPlayer._played;
        },
        action: function () {
            cleverapps.prefabPlayer._played = true;

            console.log("prefabPlayer run");
            cleverapps.prefabPlayer.run();
        }
    },

    createShortcut: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        filter: function () {
            return !cleverapps.config.features.includes("shortcut_mission")
                && connector.platform.canCreateShortcut()
                && levels.user.checkAvailable(cleverapps.config.availables.CREATE_SHORTCUT);
        },
        action: function () {
            connector.platform.createShortcutCallback();
        },
        interval: "10 minutes"
    },

    joinGroup: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        filter: function () {
            return connector.social.isSupportsNativeCommunityJoin && levels.user.checkAvailable(cleverapps.config.availables.JOIN_GROUP);
        },
        action: function () {
            connector.social.joinCommunityNativeCallback();
        },
        interval: "7 days",
        delayFromStart: "10 minutes"
    },

    showRestore: {
        type: Placements.FREE_FOCUS,
        filter: function () {
            return cleverapps.paymentsLogic.pendingPurchaseToRestore;
        },
        action: function () {
            cleverapps.paymentsLogic.showRestore();
        }
    },

    subscriptionOffer: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        filter: function () {
            return cleverapps.subscription.needDisplayWindow();
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "SubscriptionWindow",
                action: function (f) {
                    new SubscriptionWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        },
        interval: function () {
            return connector.platform.oneOf(connector.OK) ? "1 day" : "3 day";
        },
        delayFromStart: "10 minutes"
    },

    minigameNudge: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        priority: 4,
        filter: function () {
            const missions = cleverapps.missionManager.getPlayableMissions();
            return missions.length > 0;
        },
        action: function () {
            const missions = cleverapps.missionManager.getPlayableMissions();

            let mission = undefined;
            for (let i = 0; i < missions.length; i++) {
                const c = missions[i];
                if (c.nudgeWindow && c.started && (c.needShowStartWindow === undefined || c.needShowStartWindow)) {
                    mission = c;
                    break;
                }
            }

            if (mission) {
                cleverapps.focusManager.display({
                    focus: "NudgeWindow",
                    action: function (f) {
                        const NudgeWindowClass = mission.nudgeWindow;
                        new NudgeWindowClass(mission);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        },
        interval: "10 minutes"
    },

    missionShowNewState: {
        type: Placements.FREE_FOCUS_MAIN,
        priority: 1000,
        filter: function () {
            return cleverapps.missionManager.getWantToShowNewStateMission();
        },
        action: function () {
            const mission = cleverapps.missionManager.getWantToShowNewStateMission();
            cleverapps.focusManager.display({
                focus: "missionWindow",
                action: function (f) {
                    const WindowClass = mission.getViewClass();
                    new WindowClass(mission);

                    mission.skipStartWindow();

                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    localstorageDisabled: {
        type: Placements.FREE_FOCUS_MAIN,
        priority: 8,
        filter: function () {
            return cleverapps.dataLoader.localStorage.supported === false && !cleverapps.dataLoader.localStorage.alerted;
        },
        action: function () {
            cleverapps.dataLoader.localStorage.alerted = true;

            cleverapps.focusManager.display({
                focus: "LocalStorageDisabledWindow",
                action: function (f) {
                    new LocalStorageDisabledWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    sideBarIcons: {
        type: Placements.FREE_FOCUS,

        action: function () {
            cleverapps.sideBar.resetOnFreeFocus();
        }
    },

    sideBarForce: {
        throttled: true,

        type: Placements.FREE_FOCUS,
        priority: 7,
        filter: function () {
            return !cleverapps.environment.isGameScene() && cleverapps.sideBar.anyIconWithForceIndex() !== undefined;
        },

        action: function () {
            cleverapps.sideBar.showAnyForce();
        }
    },

    triggerGameCounter: {
        type: Placements.FREE_FOCUS_GAME,
        priority: 0,
        filter: function () {
            if (typeof Game !== "undefined") {
                return Game.currentGame;
            }

            if (typeof Map2dLocation !== "undefined") {
                return Map2dLocation.currentLocation;
            }
        },

        action: function () {
            if (typeof Game !== "undefined") {
                Game.currentGame.counter.trigger();
            }

            if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation) {
                Map2dLocation.currentLocation.counter.trigger();
            }
        }
    },

    toolbarForce: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,

        filter: function () {
            return cleverapps.toolbar.anyItemWithForce();
        },

        action: function () {
            cleverapps.toolbar.showAnyForce();
        }
    },

    offerManagerRefresh: {
        type: Placements.FREE_FOCUS,
        priority: 1,
        filter: function () {
            if (connector.platform.oneOf(connector.G5WINDOWS) && !connector.payments.getPlugin().productsLoaded
                && cleverapps.timeStart + cleverapps.parseInterval("2 minutes") > Date.now()) {
                return false;
            }

            return cleverapps.environment.isMainScene() && !cleverapps.config.demoMode;
        },

        action: function () {
            cleverapps.offerManager.refreshAll();
        }
    },

    offerManagerProcess: {
        throttled: true,

        type: Placements.FREE_FOCUS,

        filter: function () {
            return cleverapps.environment.isMainScene() && !cleverapps.config.demoMode
                && Boolean(cleverapps.offerManager.findOfferWithPendingWindow());
        },

        action: function () {
            cleverapps.offerManager.showPendingOffer();
        }
    },

    localPushes: {
        type: Placements.ONSHOW_OR_STARTUP,
        action: function () {
            cleverapps.user.sendLetsPlayPush();
        }
    },

    showTwoTabsWindow: {
        type: Placements.FREE_FOCUS | Placements.SYSTEM_FAULT,
        priority: 10000,
        filter: function () {
            return cleverapps.playInTwoTabs.wantsTwoTabsWindow && !TwoTabsWindow.showed && cleverapps.Scenes.GetRunningScene()
                && cleverapps.Scenes.GetRunningScene().sceneComponent.isSceneReady()
                && !cleverapps.environment.isSceneWithPreview() && !cleverapps.environment.isAtlasAnalyzerScene();
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "TwoTabsWindow",
                action: function () {
                    new TwoTabsWindow();
                }
            });
        }
    },

    userDelete: {
        type: Placements.FREE_FOCUS,
        filter: function () {
            return cleverapps.userDelete.isDeleted();
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "UserDeleteWindow",
                action: (f) => {
                    cleverapps.userDelete.checkDeletion(f);
                }
            });
        }
    },

    checkConnection: {
        throttled: true,

        type: Placements.FREE_FOCUS,
        filter: function () {
            return !cleverapps.flags.nologin && !connector.social.isLoggedIn() && cleverapps.user.checkAvailable(cleverapps.config.availables.CHECK_CONNECTION);
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "checkConnection",
                action: function (f) {
                    cleverapps.SocialManager.enforceLogin(f, {
                        withWindow: true
                    });
                }
            });
        },
        interval: "7 days"
    },

    mergeRateWindow: {
        throttled: true,

        type: Placements.FREE_FOCUS,
        filter: function () {
            return ["merge", "merge2"].includes(cleverapps.config.type) && RateWindow.CanRate();
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "nativePlacementRate",
                action: function (f) {
                    new RateWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    subscriptionReload: {
        type: Placements.ONSHOW_OR_STARTUP,
        filter: function () {
            return cleverapps.subscription;
        },
        action: function () {
            cleverapps.subscription.reload();
        }
    },

    missionManagerProcess: {
        throttled: true,

        type: Placements.FREE_FOCUS,
        priority: 2,
        filter: function () {
            return cleverapps.environment.isMainScene() && !cleverapps.config.demoMode;
        },

        action: function () {
            cleverapps.missionManager.run();

            const mission = cleverapps.missionManager.pendingStartWindow();
            if (mission) {
                cleverapps.missionManager.showStartWindow(mission);
            }
        },
        delayFromStart: "1 minutes"
    },

    missionTeaserShowing: {
        type: Placements.FREE_FOCUS,
        priority: 2,
        filter: function () {
            return cleverapps.environment.isMainScene() && !cleverapps.config.demoMode;
        },

        action: function () {
            cleverapps.missionManager.showTeaser();
        }
    },

    saveAfterMigrations: {
        type: Placements.FREE_FOCUS,
        priority: 2,
        filter: function () {
            return cleverapps.missionManager.needSaveAfterMigration || cleverapps.meta.needSaveAfterMigration || cleverapps.meta.needSaveAfterSlotMigration;
        },

        action: function () {
            if (cleverapps.missionManager.needSaveAfterMigration) {
                cleverapps.missionManager.needSaveAfterMigration = false;
                cleverapps.missionManager.save();
            }

            if (cleverapps.meta.needSaveAfterMigration) {
                cleverapps.meta.needSaveAfterMigration = false;
                cleverapps.meta.save();
            }

            if (cleverapps.meta.needSaveAfterSlotMigration) {
                cleverapps.meta.needSaveAfterSlotMigration = false;

                const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
                slot.addUpdateTask("all");
            }
        }
    },

    missionFinished: {
        type: Placements.FREE_FOCUS,
        priority: 900,
        filter: function () {
            if (!cleverapps.config.demoMode) {
                cleverapps.missionManager.removeSilents();
                if (cleverapps.environment.isMainScene()) {
                    return cleverapps.missionManager.wantsToShowCompleted();
                }
            }
        },

        action: function () {
            const mission = cleverapps.missionManager.wantsToShowCompleted();
            if (mission) {
                cleverapps.focusManager.display({
                    focus: `missionCompleted${mission.name}`,
                    action: function (f) {
                        mission.displayCompleted(f);
                    }
                });
            }
        }
    },

    missionStartWindow: {
        throttled: true,

        type: Placements.FREE_FOCUS,
        priority: 6,
        filter: function () {
            return cleverapps.environment.isMainScene() && cleverapps.missionManager.pendingStartWindow();
        },

        action: function () {
            cleverapps.missionManager.showStartWindow(cleverapps.missionManager.pendingStartWindow());
        }
    },

    showChatPresents: {
        priority: 1,
        type: Placements.FREE_FOCUS,

        filter: function () {
            return cleverapps.chatPresents !== undefined
                && (cleverapps.environment.isMainScene() || cleverapps.environment.isGameScene());
        },

        action: function () {
            cleverapps.chat.giveRewards();
        }
    },

    subscriptionReward: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        interval: "1 day",

        filter: function () {
            return cleverapps.subscription.isRewardReady() && Subscription.IsAvailable();
        },

        action: function () {
            cleverapps.focusManager.display({
                focus: "SubscriptionReward",
                action: function (f) {
                    new ShopWindow({
                        tab: ShopWindow.TABS.HARD_CURRENCY, attention: ["subsMonth"], finger: true
                    });

                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    fallSaleWindow: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        priority: 50,
        once: true,

        filter: function () {
            return cleverapps.fallSale && cleverapps.fallSale.needToShowWindow();
        },

        action: function () {
            cleverapps.fallSale.showWindow();
        }
    },

    subscribeBot: {
        type: Placements.STARTUP,
        filter: function () {
            return cleverapps.platformLogic.subscribeBot;
        },
        action: function () {
            cleverapps.platformLogic.subscribeBot();
        },
        interval: "3 days"
    },

    loadOldUserId: {
        type: Placements.ONSHOW_OR_STARTUP,
        filter: function () {
            return cleverapps.platformLogic.loadOldUserId && !cleverapps.platformLogic.oldUserId;
        },
        action: function () {
            cleverapps.platformLogic.loadOldUserId((oldUserId, oldUser) => {
                if (oldUserId && connector.platform.getUserID() !== oldUserId) {
                    console.log("old userId loaded", oldUserId);
                    cleverapps.platformLogic.oldUserId = oldUserId;
                    cleverapps.platformLogic.oldUserSource = oldUser && oldUser.source;
                    cleverapps.userIdsHistory.add(oldUserId);
                }

                let code = "empty";
                if (oldUserId) {
                    code = connector.platform.getUserID() !== oldUserId ? "other" : "self";

                    if (oldUser && oldUser.episode !== undefined && oldUser.level !== undefined) {
                        const compare = (cleverapps.user.currentPhysicalLevel.episode - oldUser.episode) || (cleverapps.user.currentPhysicalLevel.level - oldUser.level);
                        if (compare < 0) {
                            code += "-better";
                        } else if (compare > 0) {
                            code += "-worse";
                        } else {
                            code += "-equals";
                        }
                    }
                }

                cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.OLD_USER_LOAD + code);

                if (cleverapps.platformLogic.oldUserId) {
                    cleverapps.placements.run(Placements.SYSTEM_FAULT);
                }
            });
        },
        interval: "1 hour"
    },

    syncOldUserId: {
        type: Placements.FREE_FOCUS | Placements.SYSTEM_FAULT,
        priority: 10000,
        filter: function () {
            return cleverapps.platformLogic.oldUserId
                && ![connector.SYNC_STATUS.CONFLICT, connector.SYNC_STATUS.PULL, connector.SYNC_STATUS.PUSH, connector.SYNC_STATUS.WAIT].includes(connector.synchronizer.status);
        },
        action: function () {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.OLD_USER_SYNC}start`);

            const fromSource = cleverapps.platformLogic.oldUserSource;

            cleverapps.importProgress(cleverapps.platformLogic.oldUserId, {
                onlyBetter: true,
                fromSource,
                callback: (code) => {
                    if (code !== "load_failed") {
                        cleverapps.platformLogic.oldUserId = undefined;
                        cleverapps.platformLogic.oldUserSource = undefined;
                    }

                    if (code === cleverapps.CODE_SUCCEED) {
                        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.DEBUG.OLD_USER_SYNC}success`);
                    }
                }
            });
        },
        interval: "1 minute"
    },

    checkAdBlock: {
        throttled: true,

        type: Placements.FREE_FOCUS_MAIN,
        filter: function () {
            return AdBlockWindow.CanBeShown();
        },
        action: function () {
            connector.ads.checkAdBlockCallback((enabled) => {
                if (enabled) {
                    cleverapps.focusManager.display({
                        focus: "AdBlockWindow",
                        action: function (f) {
                            new AdBlockWindow();
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    });
                }
            });
        }
    },

    reportScore: {
        type: Placements.ONSHOW_OR_STARTUP,
        filter: function () {
            if (connector.platform.oneOf(connector.SAMSUNG)) {
                return ["merge", "merge2"].includes(cleverapps.config.type);
            }

            return !connector.platform.oneOf(connector.GAMESNACK, connector.YOUTUBE);
        },
        action: function () {
            if (cleverapps.instantTournament.isAvailable()) {
                cleverapps.instantTournament.reportScore();
            } else {
                cleverapps.scoreTracker.report();
            }
        }
    },

    wechatShutdown: {
        type: Placements.FREE_FOCUS,
        priority: 10000,
        once: true,
        filter: function () {
            return cleverapps.config.name === "fairy" && connector.platform.oneOf(connector.WECHAT);
        },
        action: function () {
            cleverapps.focusManager.display({
                focus: "WechatShutdownWindow",
                action: function (f) {
                    new WechatShutdownWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    },

    chat: {
        type: Placements.ONSHOW,
        action: function () {
            cleverapps.chat.load();
        },
        interval: "1 minute"
    },

    crossPromoMarkUpdate: {
        type: Placements.FREE_FOCUS,
        action: function () {
            MenuControlButton.updateAttention();
        },
        filter: function () {
            return cleverapps.crossPromo && cleverapps.crossPromo.hasMark();
        }
    },

    friendRequests: {
        type: Placements.ONSHOW_OR_STARTUP,
        action: function () {
            levels.friendRequests.serverReload(true);
            FakeRequestSender.sendIfNeed();
        },
        interval: "1 minute"
    },

    startTutorialScenario: {
        priority: -1000,
        type: Placements.FREE_FOCUS_MAIN | Placements.FREE_FOCUS_OTHER,

        filter: function () {
            return cleverapps.tutorial && cleverapps.tutorial.getAvailableScenario();
        },

        action: function () {
            cleverapps.tutorial.startScenario();
        }
    },

    savedTutorialScenario: {
        priority: 99,
        type: Placements.FREE_FOCUS_MAIN | Placements.FREE_FOCUS_OTHER,

        filter: function () {
            return cleverapps.tutorial && cleverapps.tutorial.hasSavedTutorial();
        },

        action: function () {
            cleverapps.tutorial.startScenario();
        }
    }
};
